"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[948],{

/***/ 38128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Checkbox_Checkbox; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Fieldset/FieldsetContext.tsx
var FieldsetContext = __webpack_require__(83734);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/Checkbox/Checkbox.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref =  true ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : 0;

var Checkbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "ejrwdcn0"
} : 0)("position:relative;width:20px;height:20px;appearance:none;cursor:pointer;::before,::after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;}::before{border:2px solid ", function (_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor;
}, ";border-radius:4px;transition:200ms ease;}:checked{::before{background-color:", function (_ref3) {
  var checkedBackgroundColor = _ref3.checkedBackgroundColor;
  return checkedBackgroundColor;
}, ";border-color:", function (_ref4) {
  var checkedBorderColor = _ref4.checkedBorderColor;
  return checkedBorderColor;
}, ";}::after{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.568.278a1.2 1.2 0 01.154 1.69l-6 7.2a1.2 1.2 0 01-1.77.08l-3.6-3.6a1.2 1.2 0 111.697-1.697l2.67 2.671L9.88.432a1.2 1.2 0 011.69-.154z' fill='%23fff'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:center;}}", function (_ref5) {
  var checked = _ref5.checked,
      checkedBackgroundColor = _ref5.checkedBackgroundColor,
      checkedBorderColor = _ref5.checkedBorderColor;
  return checked &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("::before{background-color:", checkedBackgroundColor, ";border-color:", checkedBorderColor, ";}::after{background-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.568.278a1.2 1.2 0 01.154 1.69l-6 7.2a1.2 1.2 0 01-1.77.08l-3.6-3.6a1.2 1.2 0 111.697-1.697l2.67 2.671L9.88.432a1.2 1.2 0 011.69-.154z' fill='%23fff'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:center;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref6) {
  var checked = _ref6.checked,
      disabled = _ref6.disabled,
      as = _ref6.as,
      hoverBorderColor = _ref6.hoverBorderColor;
  return !disabled && !checked && as &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(":hover{::before{border-color:", hoverBorderColor, ";}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref7) {
  var as = _ref7.as,
      hoverBorderColor = _ref7.hoverBorderColor;
  return !as &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(":not(:checked):not(:disabled){:hover{::before{border-color:", hoverBorderColor, ";}}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Checkbox/Checkbox.tsx


var _excluded = ["name", "value", "disabled", "onChange", "tag", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseCheckbox = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
      value = _ref.value,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      tag = _ref.tag,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var fieldsetContext = (0,FieldsetContext/* useFieldset */.w)();
  var isDisabled = disabled || (fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.disabledFieldset);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox, _objectSpread(_objectSpread({
    name: name,
    type: "checkbox",
    value: value,
    disabled: Boolean(isDisabled),
    onChange: onChange,
    ref: ref,
    as: tag
  }, rest), tokens));
});
var Checkbox_Checkbox = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCheckbox, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[400],
      hoverBorderColor: theme.palette.brand.darkAcai[500],
      checkedBackgroundColor: theme.palette.brand.segmentGreen[500],
      checkedBorderColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[500],
      hoverBorderColor: theme.palette.brand.darkAcai[400],
      checkedBackgroundColor: theme.palette.brand.segmentGreen[500],
      checkedBorderColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[40],
      hoverBorderColor: theme.palette.twilio.gray[60],
      checkedBackgroundColor: theme.palette.twilio.blue[60],
      checkedBorderColor: theme.palette.twilio.blue[60]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Checkbox/index.ts


/***/ }),

/***/ 83734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FieldsetContextProvider; },
/* harmony export */   "w": function() { return /* binding */ useFieldset; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var FieldsetContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var FieldsetContextProvider = FieldsetContext.Provider;
var useFieldset = function useFieldset() {
  var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(FieldsetContext);
  return context;
};

/***/ }),

/***/ 19727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input_ErrorSlot; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/Input/ErrorSlot.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var ErrorWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e1mkl79w3"
} : 0)("top:calc(100% + 8px);text-align:left;min-height:15px;max-width:100%;display:block;position:absolute;", function (_ref) {
  var fullErrorMessageGap = _ref.fullErrorMessageGap;
  return fullErrorMessageGap &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("top:calc(100% - ", fullErrorMessageGap, "px);" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var HelperLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1mkl79w2"
} : 0)( true ? {
  name: "1e1tsha",
  styles: "margin:0 0 0 5px;margin-top:1px;display:inline"
} : 0);
var ErrorLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1mkl79w1"
} : 0)("margin:0;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";" + ( true ? "" : 0));
var LabelWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1mkl79w0"
} : 0)("position:relative;margin:0;display:block;color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";white-space:", function (_ref4) {
  var showFullMessage = _ref4.showFullMessage;
  return showFullMessage ? "unset" : "nowrap";
}, ";overflow:", function (_ref5) {
  var showFullMessage = _ref5.showFullMessage;
  return showFullMessage ? "unset" : "hidden";
}, ";text-overflow:", function (_ref6) {
  var showFullMessage = _ref6.showFullMessage;
  return showFullMessage ? "unset" : "ellipsis";
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Input/ErrorSlot.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var BaseErrorSlot = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var inputName = _ref.inputName,
      errorText = _ref.errorText,
      helperLink = _ref.helperLink,
      helperText = _ref.helperText,
      fullErrorMessageGap = _ref.fullErrorMessageGap,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorWrapper, {
    ref: ref,
    title: errorText,
    initial: "initial",
    variants: {
      initial: {
        opacity: 0,
        y: 5
      },
      animate: {
        opacity: 1,
        y: 0
      }
    },
    animate: errorText ? "animate" : "initial",
    transition: {
      duration: 0.2
    },
    fullErrorMessageGap: fullErrorMessageGap,
    children: errorText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelWrapper, _objectSpread(_objectSpread({
        showFullMessage: Boolean(fullErrorMessageGap)
      }, tokens), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorLabel, _objectSpread(_objectSpread({
          variant: "textRegularSmall",
          id: "".concat(inputName, "-message"),
          role: "alert"
        }, tokens), {}, {
          children: errorText
        })), helperLink ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HelperLink, {
          variant: "textRegularSmall",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: helperLink,
            children: helperText
          })
        }) : null]
      }))
    })
  });
});
var ErrorSlot = (0,useDesignTokens/* withDesignTokens */.Y)(BaseErrorSlot, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.status.error[200]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.status.error[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.status.error[200]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      color: theme.palette.status.error[200]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.status.error[100]
    };
  }
});
/* harmony default export */ var Input_ErrorSlot = (ErrorSlot);

/***/ }),

/***/ 94261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ ErrorSlot/* default */.Z; },
  "Z": function() { return /* reexport */ Input; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Fieldset/FieldsetContext.tsx
var FieldsetContext = __webpack_require__(83734);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/Input/Input.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}





var _ref =  true ? {
  name: "546l7a",
  styles: "visibility:hidden;position:absolute"
} : 0;

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewk11xd9"
} : 0)("position:relative;display:grid;row-gap:8px;width:", function (_ref2) {
  var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? "unset" : _ref2$width;
  return width;
}, ";opacity:", function (_ref3) {
  var _ref3$opacity = _ref3.opacity,
      opacity = _ref3$opacity === void 0 ? 1 : _ref3$opacity;
  return opacity;
}, ";", function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden && _ref;
}, ";" + ( true ? "" : 0));

var getShadowStyles = function getShadowStyles(shadowColor) {
  return shadowColor &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:0px 0px 0px 1px ", shadowColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
};

var Field = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "ewk11xd8"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.formInput;
}, ";overflow:hidden;text-overflow:ellipsis;padding:17px 20px 17px 20px;border-radius:5px;border:1px solid transparent;outline:none;transition:border-color 0.3s,box-shadow 0.3s,background 0.3s;width:100%;padding-right:", function (_ref6) {
  var paddingRight = _ref6.paddingRight;
  return paddingRight;
}, ";padding-left:", function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft;
}, ";::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{-webkit-appearance:none;}appearance:none;background-color:", function (_ref8) {
  var backgroundColor = _ref8.backgroundColor;
  return backgroundColor;
}, ";border-color:", function (_ref9) {
  var borderColor = _ref9.borderColor;
  return borderColor;
}, ";color:", function (_ref10) {
  var color = _ref10.color;
  return color;
}, ";", function (_ref11) {
  var shadowColor = _ref11.shadowColor;
  return getShadowStyles(shadowColor);
}, ";::placeholder{color:", function (_ref12) {
  var placeholderColor = _ref12.placeholderColor;
  return placeholderColor;
}, ";opacity:", function (_ref13) {
  var _ref13$placeholderOpa = _ref13.placeholderOpacity,
      placeholderOpacity = _ref13$placeholderOpa === void 0 ? 1 : _ref13$placeholderOpa;
  return placeholderOpacity;
}, ";}:hover{background-color:", function (_ref14) {
  var hoverBackgroundColor = _ref14.hoverBackgroundColor;
  return hoverBackgroundColor;
}, ";border-color:", function (_ref15) {
  var hoverBorderColor = _ref15.hoverBorderColor;
  return hoverBorderColor;
}, ";", function (_ref16) {
  var hoverShadowColor = _ref16.hoverShadowColor;
  return getShadowStyles(hoverShadowColor);
}, ";::placeholder{color:", function (_ref17) {
  var hoverPlaceholderColor = _ref17.hoverPlaceholderColor;
  return hoverPlaceholderColor;
}, ";}}:focus{border-color:", function (_ref18) {
  var focusBorderColor = _ref18.focusBorderColor;
  return focusBorderColor;
}, ";", function (_ref19) {
  var focusShadowColor = _ref19.focusShadowColor;
  return getShadowStyles(focusShadowColor);
}, ";}:disabled{pointer-events:none;border-color:", function (_ref20) {
  var disabledBorderColor = _ref20.disabledBorderColor;
  return disabledBorderColor;
}, ";opacity:", function (_ref21) {
  var disabledOpacity = _ref21.disabledOpacity;
  return disabledOpacity;
}, ";}:-webkit-autofill{box-shadow:none;-webkit-box-shadow:none;-webkit-text-fill-color:", function (_ref22) {
  var autoFillColor = _ref22.autoFillColor;
  return autoFillColor;
}, ";transition:background-color 5000s ease-in-out 0s;caret-color:", function (_ref23) {
  var autoFillCaretColor = _ref23.autoFillCaretColor;
  return autoFillCaretColor;
}, ";}" + ( true ? "" : 0));
var FieldWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewk11xd7"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ewk11xd6"
} : 0)("margin:0;display:block;color:", function (_ref24) {
  var color = _ref24.color;
  return color;
}, ";" + ( true ? "" : 0));
var RightIconsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewk11xd5"
} : 0)( true ? {
  name: "1fev8i1",
  styles: "display:flex;position:absolute;z-index:1;top:50%;transform:translateY(-50%);right:17px;pointer-events:none"
} : 0);
var ClearButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ewk11xd4"
} : 0)( true ? {
  name: "1pxslb0",
  styles: "display:flex;cursor:pointer;color:currentColor"
} : 0);
var RightIconSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewk11xd3"
} : 0)("display:flex;min-height:16px;min-width:16px;align-items:center;pointer-events:", function (_ref25) {
  var _ref25$disableEvents = _ref25.disableEvents,
      disableEvents = _ref25$disableEvents === void 0 ? false : _ref25$disableEvents;
  return disableEvents ? "none" : "all";
}, ";color:", function (_ref26) {
  var color = _ref26.color;
  return color;
}, ";align-items:center;" + ( true ? "" : 0));
var LeftIconSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewk11xd2"
} : 0)("display:flex;min-height:24px;min-width:24px;position:absolute;z-index:1;left:20px;top:50%;transform:translateY(-50%);color:", function (_ref27) {
  var color = _ref27.color;
  return color;
}, ";" + ( true ? "" : 0));
var ErrorWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ewk11xd1"
} : 0)( true ? {
  name: "1ozs8tz",
  styles: "margin:0 0 0.25rem;text-align:left;min-height:16px"
} : 0);
var AnimatedErrorMessageGap = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ewk11xd0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/ErrorSlot.tsx + 1 modules
var ErrorSlot = __webpack_require__(19727);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Input/Input.tsx


var _excluded = ["type", "name", "id", "placeholder", "label", "errorText", "required", "readonly", "error", "showValidState", "value", "onChange", "onBlur", "disabled", "resetable", "icon", "rightSecondIcon", "clearIcon", "onClear", "dataHook", "onAutoFill", "autoComplete", "helperLink", "helperText", "tokens", "after", "isLoading", "fullErrorMessageGap"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseInput = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      label = _ref.label,
      errorText = _ref.errorText,
      required = _ref.required,
      readonly = _ref.readonly,
      error = _ref.error,
      showValidState = _ref.showValidState,
      _ref$value = _ref.value,
      externalValue = _ref$value === void 0 ? "" : _ref$value,
      _onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      disabled = _ref.disabled,
      resetable = _ref.resetable,
      icon = _ref.icon,
      rightSecondIcon = _ref.rightSecondIcon,
      _ref$clearIcon = _ref.clearIcon,
      clearIcon = _ref$clearIcon === void 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {}) : _ref$clearIcon,
      onClear = _ref.onClear,
      dataHook = _ref.dataHook,
      onAutoFill = _ref.onAutoFill,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "on" : _ref$autoComplete,
      helperLink = _ref.helperLink,
      helperText = _ref.helperText,
      tokens = _ref.tokens,
      after = _ref.after,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      fullErrorMessageGap = _ref.fullErrorMessageGap,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var fieldRef = (0,react.useRef)(null);
  var fieldsetContext = (0,FieldsetContext/* useFieldset */.w)();
  var isDisabled = disabled || (fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.disabledFieldset);

  var _useState = (0,react.useState)(externalValue),
      value = _useState[0],
      setValue = _useState[1];

  (0,react.useEffect)(function () {
    setValue(externalValue);
  }, [externalValue]);
  (0,react.useImperativeHandle)(ref, function () {
    return fieldRef.current;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens.wrapper), {}, {
    children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, _objectSpread(_objectSpread({
      htmlFor: id,
      variant: "formLabel",
      tag: "label"
    }, tokens.label), {}, {
      children: label
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FieldWrapper, {
      children: [icon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIconSlot, {
        color: tokens.field.color,
        children: icon
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field, _objectSpread(_objectSpread({
        type: type,
        name: name,
        id: id,
        placeholder: placeholder,
        required: required,
        disabled: isDisabled,
        readOnly: readonly,
        value: value,
        onChange: function onChange(event) {
          if (!readonly) {
            setValue(event.target.value);
            _onChange === null || _onChange === void 0 ? void 0 : _onChange(event, event.target.value);

            if (event.target.value.length > value.length + 2 && event.target.value !== value && event.target.value !== "") {
              onAutoFill === null || onAutoFill === void 0 ? void 0 : onAutoFill(event.target.value);
            }
          }
        },
        ref: fieldRef,
        "aria-invalid": error,
        "aria-errormessage": "".concat(name, "-message"),
        onBlur: onBlur,
        "data-hook": dataHook,
        autoComplete: autoComplete
      }, rest), tokens.field)), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RightIconsWrapper, {
        children: [error && !isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightIconSlot, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ErrorIcon */.Pz, _objectSpread({}, tokens.errorIcon))
        }), showValidState && !error && value && !isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightIconSlot, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* CheckIcon */.nQ, _objectSpread({}, tokens.successIcon))
        }), isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightIconSlot, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* ButtonLoader */.l, {
            loading: isLoading,
            delay: 0
          })
        }), resetable && Boolean(value) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightIconSlot, {
          color: tokens.field.color,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClearButton, {
            "aria-label": "Reset value",
            onClick: function onClick() {
              setValue("");
              onClear === null || onClear === void 0 ? void 0 : onClear();
            },
            children: clearIcon
          })
        }), rightSecondIcon && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RightIconSlot, {
          color: tokens.field.color,
          disableEvents: true,
          children: rightSecondIcon
        })]
      })]
    }), after ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [after, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
        children: errorText && fullErrorMessageGap ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatedErrorMessageGap, {
          initial: {
            height: 0
          },
          animate: {
            height: fullErrorMessageGap
          },
          exit: {
            height: 0
          }
        }) : null
      })]
    }) : null, errorText ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorSlot/* default */.Z, {
      inputName: name,
      errorText: errorText,
      tokens: tokens.errorLabel,
      helperLink: helperLink,
      helperText: helperText,
      fullErrorMessageGap: fullErrorMessageGap
    }) : null]
  }));
});

var getFieldTokens = function getFieldTokens(props) {
  var basePaddingRight = 20;
  var hasRightIcon = Boolean(props.error || props.showValidState || props.resetable);
  var hasSecondRightIcon = Boolean(props.rightSecondIcon);
  var extraPaddingRight = [hasRightIcon, hasSecondRightIcon].reduce(function (totalExtraPadding, hasIcon) {
    return hasIcon ? totalExtraPadding + 24 : totalExtraPadding;
  }, 0);
  return {
    paddingRight: "".concat(basePaddingRight + extraPaddingRight, "px"),
    paddingLeft: props.icon ? "55px" : ""
  };
};

var Input = (0,useDesignTokens/* withDesignTokens */.Y)(BaseInput, function (props) {
  return {
    wrapper: _objectSpread(_objectSpread(_objectSpread({}, props.disabled && {
      opacity: 0.75
    }), props.expanded && {
      width: "100%"
    }), {}, {
      hidden: props.type === "hidden"
    })
  };
}, {
  light: function light(theme, props) {
    return {
      field: _objectSpread(_objectSpread({}, getFieldTokens(props)), {}, {
        backgroundColor: theme.palette.neutrals.white[100],
        borderColor: theme.palette.brand.darkAcai[300],
        color: theme.palette.brand.darkAcai[700],
        shadowColor: theme.palette.brand.darkAcai[300],
        placeholderColor: theme.palette.brand.darkAcai[500],
        placeholderOpacity: 0.75,
        hoverBackgroundColor: theme.palette.brand.darkAcai[100],
        hoverBorderColor: theme.palette.brand.darkAcai[300],
        hoverPlaceholderColor: theme.palette.brand.darkAcai[500],
        focusBorderColor: theme.palette.brand.darkAcai[600],
        focusShadowColor: theme.palette.brand.darkAcai[600],
        disabledBorderColor: theme.palette.brand.darkAcai[300],
        disabledOpacity: 1,
        autoFillColor: theme.palette.brand.darkAcai[700],
        autoFillCaretColor: theme.palette.brand.darkAcai[700]
      }, props.error && {
        borderColor: theme.palette.status.error[200],
        shadowColor: theme.palette.status.error[200],
        hoverBorderColor: theme.palette.status.error[200],
        focusBorderColor: theme.palette.status.error[200],
        focusShadowColor: theme.palette.status.error[200]
      }),
      label: {
        color: theme.palette.brand.darkAcai[500]
      },
      successIcon: {
        color: theme.palette.status.success[200]
      },
      errorIcon: {
        color: theme.palette.status.error[200]
      }
    };
  },
  dark: function dark(theme, props) {
    return {
      field: _objectSpread(_objectSpread({}, getFieldTokens(props)), {}, {
        backgroundColor: theme.palette.brand.darkAcai[600],
        borderColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.neutrals.white[100],
        shadowColor: theme.palette.brand.darkAcai[600],
        placeholderColor: theme.palette.brand.darkAcai[200],
        placeholderOpacity: 0.7,
        hoverBackgroundColor: theme.palette.brand.darkAcai[600],
        hoverBorderColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100]),
        hoverShadowColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100]),
        hoverPlaceholderColor: theme.palette.brand.darkAcai[200],
        focusBorderColor: theme.palette.brand.darkAcai[300],
        focusShadowColor: theme.palette.brand.darkAcai[300],
        disabledBorderColor: theme.palette.brand.darkAcai[600],
        disabledOpacity: 0.7,
        autoFillColor: theme.palette.neutrals.white[100],
        autoFillCaretColor: theme.palette.neutrals.white[100]
      }, props.error && {
        borderColor: theme.palette.status.error[100],
        shadowColor: theme.palette.status.error[100],
        hoverBorderColor: theme.palette.status.error[100],
        hoverShadowColor: theme.palette.status.error[100],
        focusBorderColor: theme.palette.status.error[100],
        focusShadowColor: theme.palette.status.error[100]
      }),
      label: {
        color: theme.palette.neutrals.white[100]
      },
      successIcon: {
        color: theme.palette.status.success[100]
      },
      errorIcon: {
        color: theme.palette.status.error[100]
      }
    };
  },
  twilioLight: function twilioLight(theme, props) {
    return {
      field: _objectSpread(_objectSpread({}, getFieldTokens(props)), {}, {
        backgroundColor: theme.palette.neutrals.white[100],
        borderColor: theme.palette.twilio.gray[30],
        color: theme.palette.twilio.gray[100],
        placeholderColor: theme.palette.twilio.gray[60],
        hoverBackgroundColor: theme.palette.neutrals.white[100],
        hoverBorderColor: theme.palette.twilio.gray[60],
        hoverPlaceholderColor: theme.palette.twilio.gray[80],
        focusBorderColor: theme.palette.twilio.gray[60],
        focusShadowColor: theme.palette.twilio.gray[60],
        disabledBorderColor: theme.palette.twilio.gray[30],
        disabledOpacity: 0.5,
        autoFillColor: theme.palette.brand.darkAcai[700],
        autoFillCaretColor: theme.palette.brand.darkAcai[700]
      }, props.error && {
        borderColor: theme.palette.status.error[200],
        shadowColor: theme.palette.status.error[200],
        hoverBorderColor: theme.palette.status.error[200],
        focusBorderColor: theme.palette.status.error[200],
        focusShadowColor: theme.palette.status.error[200]
      }),
      label: {
        color: theme.palette.twilio.gray[80]
      },
      successIcon: {
        color: theme.palette.twilio.blue[60]
      },
      errorIcon: {
        color: theme.palette.status.error[200]
      }
    };
  },
  twilioDark: function twilioDark(theme, props) {
    return {
      field: _objectSpread(_objectSpread({}, getFieldTokens(props)), {}, {
        backgroundColor: theme.palette.neutrals.white[100],
        borderColor: theme.palette.twilio.gray[30],
        color: theme.palette.twilio.gray[100],
        placeholderColor: theme.palette.twilio.gray[60],
        hoverBackgroundColor: theme.palette.neutrals.white[100],
        hoverBorderColor: theme.palette.twilio.gray[60],
        hoverPlaceholderColor: theme.palette.twilio.gray[80],
        focusBorderColor: theme.palette.twilio.gray[60],
        focusShadowColor: theme.palette.twilio.gray[60],
        disabledBorderColor: theme.palette.twilio.gray[30],
        disabledOpacity: 0.5,
        autoFillColor: theme.palette.brand.darkAcai[700],
        autoFillCaretColor: theme.palette.brand.darkAcai[700]
      }, props.error && {
        borderColor: theme.palette.status.error[200],
        shadowColor: theme.palette.status.error[200],
        hoverBorderColor: theme.palette.status.error[200],
        focusBorderColor: theme.palette.status.error[200],
        focusShadowColor: theme.palette.status.error[200]
      }),
      label: {
        color: theme.palette.neutrals.white[100]
      },
      successIcon: {
        color: theme.palette.twilio.blue[60]
      },
      errorIcon: {
        color: theme.palette.status.error[200]
      }
    };
  },
  cdpWeek2023: function cdpWeek2023(theme, props) {
    return {
      field: _objectSpread(_objectSpread({}, getFieldTokens(props)), {}, {
        backgroundColor: theme.palette.neutrals.white[100],
        borderColor: theme.palette.twilio.gray[30],
        color: theme.palette.twilio.gray[100],
        placeholderColor: theme.palette.twilio.gray[60],
        hoverBackgroundColor: theme.palette.neutrals.white[100],
        hoverBorderColor: theme.palette.twilio.gray[60],
        hoverPlaceholderColor: theme.palette.twilio.gray[80],
        focusBorderColor: theme.palette.twilio.gray[60],
        focusShadowColor: theme.palette.twilio.gray[60],
        disabledBorderColor: theme.palette.twilio.gray[30],
        disabledOpacity: 0.5,
        autoFillColor: theme.palette.brand.darkAcai[700],
        autoFillCaretColor: theme.palette.brand.darkAcai[700]
      }, props.error && {
        borderColor: theme.palette.status.error[200],
        shadowColor: theme.palette.status.error[200],
        hoverBorderColor: theme.palette.status.error[200],
        focusBorderColor: theme.palette.status.error[200],
        focusShadowColor: theme.palette.status.error[200]
      }),
      label: {
        color: theme.palette.twilio.gray[80]
      },
      successIcon: {
        color: theme.palette.twilio.blue[60]
      },
      errorIcon: {
        color: theme.palette.status.error[200]
      }
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Input/index.ts



/***/ }),

/***/ 94441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Io": function() { return /* binding */ ModalHead; },
/* harmony export */   "fe": function() { return /* binding */ ModalBody; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "mz": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Elevation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33606);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var ModalHead = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "elwqdxd3"
} : 0)( true ? {
  name: "1n7keil",
  styles: "display:flex;align-items:center;justify-content:space-between;gap:16px;flex:0 1 auto;padding:16px"
} : 0);
var ModalBody = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "elwqdxd2"
} : 0)( true ? {
  name: "1nhqexb",
  styles: "padding:24px;flex:1;overflow-y:auto"
} : 0);
var ModalFooter = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "elwqdxd1"
} : 0)( true ? {
  name: "ewsg4e",
  styles: "display:flex;justify-content:flex-end;flex:0 1 auto;padding:16px"
} : 0);
var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Elevation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "elwqdxd0"
} : 0)("display:flex;flex-direction:column;width:100%;max-height:100%;border-radius:10px;overflow:hidden;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";max-width:", function (_ref2) {
  var maxWidth = _ref2.maxWidth,
      fullScreen = _ref2.fullScreen;
  return fullScreen ? "100%" : "".concat(maxWidth, "px");
}, ";height:", function (_ref3) {
  var fullScreen = _ref3.fullScreen;
  return fullScreen ? "100%" : "auto";
}, ";", ModalHead, "{border-bottom:1px solid ", function (_ref4) {
  var sectionSeparatorColor = _ref4.sectionSeparatorColor;
  return sectionSeparatorColor;
}, ";}", ModalFooter, "{border-top:1px solid ", function (_ref5) {
  var sectionSeparatorColor = _ref5.sectionSeparatorColor;
  return sectionSeparatorColor;
}, ";}" + ( true ? "" : 0));

/***/ }),

/***/ 33400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Modal_views/* ModalBody */.fe; },
  "$_": function() { return /* reexport */ Modal_views/* ModalFooter */.mz; },
  "Fb": function() { return /* reexport */ Modal_views/* ModalHead */.Io; },
  "ZP": function() { return /* reexport */ ModalBase; }
});

// UNUSED EXPORTS: Overlay

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Modal/ModalOverlay.tsx



var _excluded = ["placement", "background", "fullScreen", "fullScreenBottomOffset", "children", "customZIndex"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var ModalOverlay = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? "top" : _ref2$placement,
      _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? "rgba(0, 0, 0, 0.48)" : _ref2$background,
      fullScreen = _ref2.fullScreen,
      fullScreenBottomOffset = _ref2.fullScreenBottomOffset,
      children = _ref2.children,
      _ref2$customZIndex = _ref2.customZIndex,
      customZIndex = _ref2$customZIndex === void 0 ? 99 : _ref2$customZIndex,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay, _objectSpread(_objectSpread({
    id: "modal-overlay",
    placement: placement,
    background: background,
    fullScreen: fullScreen,
    fullScreenBottomOffset: fullScreenBottomOffset,
    ref: ref,
    customZIndex: customZIndex
  }, rest), {}, {
    children: children
  }));
});

var _ref =  true ? {
  name: "1h3rtzg",
  styles: "align-items:center"
} : 0;

var Overlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5irn6v0"
} : 0)("position:fixed;top:0;left:0;bottom:0;right:0;z-index:", function (_ref3) {
  var customZIndex = _ref3.customZIndex;
  return customZIndex;
}, ";display:flex;justify-content:center;align-items:start;background-color:", function (_ref4) {
  var background = _ref4.background;
  return background;
}, ";padding:", function (_ref5) {
  var fullScreen = _ref5.fullScreen,
      _ref5$fullScreenBotto = _ref5.fullScreenBottomOffset,
      fullScreenBottomOffset = _ref5$fullScreenBotto === void 0 ? 0 : _ref5$fullScreenBotto;
  return fullScreen ? "20px 20px ".concat(20 + fullScreenBottomOffset, "px 20px") : "60px 16px";
}, ";overflow:auto;", function (_ref6) {
  var placement = _ref6.placement;
  return placement === "center" && _ref;
}, " ", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("md");
}, "{padding:", function (_ref8) {
  var fullScreen = _ref8.fullScreen,
      _ref8$fullScreenBotto = _ref8.fullScreenBottomOffset,
      fullScreenBottomOffset = _ref8$fullScreenBotto === void 0 ? 0 : _ref8$fullScreenBotto;
  return fullScreen ? "25px 25px ".concat(25 + fullScreenBottomOffset, "px 25px") : "64px";
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/Modal.views.tsx
var Modal_views = __webpack_require__(94441);
;// CONCATENATED MODULE: ../../libs/matcha/components/Modal/Modal.tsx


var Modal_excluded = ["tokens", "fullScreen", "fullScreenBottomOffset", "placement", "children", "customZIndex"];

function Modal_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Modal_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Modal_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Modal_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var Modal = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      fullScreen = _ref.fullScreen,
      fullScreenBottomOffset = _ref.fullScreenBottomOffset,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      children = _ref.children,
      customZIndex = _ref.customZIndex,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Modal_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalOverlay, {
    fullScreen: fullScreen,
    fullScreenBottomOffset: fullScreenBottomOffset,
    placement: placement,
    customZIndex: customZIndex,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_views/* Wrapper */.im, Modal_objectSpread(Modal_objectSpread(Modal_objectSpread({}, tokens), {}, {
      role: "dialog",
      elevation: 1,
      ref: ref,
      fullScreen: fullScreen
    }, rest), {}, {
      children: children
    }))
  });
});
var sizes = {
  small: 384,
  medium: 448,
  large: 512,
  xlarge: 576
};
var ModalBase = (0,useDesignTokens/* withDesignTokens */.Y)(Modal, function (_ref2) {
  var size = _ref2.size;
  return {
    maxWidth: sizes[size || "medium"]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.brand.darkAcai[200]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[600],
      sectionSeparatorColor: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.twilio.gray[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.twilio.gray[20]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      backgroundColor: theme.palette.cdpWeek2023.gray[90],
      sectionSeparatorColor: theme.palette.cdpWeek2023.gray[80]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Modal/index.ts


ModalBase.displayName = "ModalBase";
Modal_views/* ModalHead.displayName */.Io.displayName = "Modal.Head";
Modal_views/* ModalBody.displayName */.fe.displayName = "Modal.Body";
Modal_views/* ModalFooter.displayName */.mz.displayName = "Modal.Footer";



/***/ }),

/***/ 44502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kr": function() { return /* reexport */ ClearSelect_ClearSelect; },
  "N1": function() { return /* reexport */ MenuItemWIthCheckbox; },
  "ZP": function() { return /* reexport */ Select; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/MenuList/index.ts + 5 modules
var components_MenuList = __webpack_require__(28536);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Menu/Menu.views.ts


var Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_MenuList/* default */.Z,  true ? {
  target: "e1mnlksa1"
} : 0)("--border-radius:5px;border-radius:var(--border-radius);border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";background-color:", function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor;
}, ";box-shadow:", function (_ref3) {
  var shadow = _ref3.shadow;
  return shadow;
}, ";scrollbar-color:", function (_ref4) {
  var scrollbar = _ref4.scrollbar;
  return "".concat(scrollbar.thumbColor, " ").concat(scrollbar.trackColor);
}, ";&::-webkit-scrollbar{width:8px;}&::-webkit-scrollbar-track{background:", function (_ref5) {
  var scrollbar = _ref5.scrollbar;
  return scrollbar.trackColor;
}, ";border-radius:var(--border-radius);}&::-webkit-scrollbar-thumb{background:", function (_ref6) {
  var scrollbar = _ref6.scrollbar;
  return scrollbar.thumbColor;
}, ";border-radius:var(--border-radius);}" + ( true ? "" : 0));
var Item = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(MenuList.Item,  true ? {
  target: "e1mnlksa0"
} : 0)( true ? "" : 0)));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Menu/Menu.tsx


var _excluded = ["appearance", "children", "tokens"],
    _excluded2 = ["focused", "selected", "tabIndex", "children", "selectedIcon"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseMenu = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var externalAppearance = _ref.appearance,
      children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: appearance,
      children: children
    })
  }));
});
var Menu_Menu = (0,useDesignTokens/* withDesignTokens */.Y)(BaseMenu, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300],
      backgroundColor: theme.palette.neutrals.white[100],
      shadow: theme.shadows[1],
      scrollbar: {
        trackColor: theme.palette.brand.darkAcai[100],
        thumbColor: theme.palette.brand.darkAcai[500]
      }
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[500],
      backgroundColor: theme.palette.brand.darkAcai[600],
      shadow: theme.shadows[1],
      scrollbar: {
        trackColor: theme.palette.brand.darkAcai[800],
        thumbColor: theme.palette.brand.darkAcai[400]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[40],
      backgroundColor: theme.palette.neutrals.white[100],
      scrollbar: {
        trackColor: theme.palette.twilio.gray[10],
        thumbColor: theme.palette.twilio.gray[60]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      borderColor: theme.palette.twilio.gray[40],
      backgroundColor: theme.palette.neutrals.white[100],
      scrollbar: {
        trackColor: theme.palette.twilio.gray[10],
        thumbColor: theme.palette.twilio.gray[60]
      }
    };
  }
});
var Menu_Item = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var focused = _ref2.focused,
      selected = _ref2.selected,
      tabIndex = _ref2.tabIndex,
      children = _ref2.children,
      _ref2$selectedIcon = _ref2.selectedIcon,
      selectedIcon = _ref2$selectedIcon === void 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* CheckIcon */.nQ, {
    size: "small"
  }) : _ref2$selectedIcon,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MenuList/* Item */.c, _objectSpread(_objectSpread({
    selectedIcon: selectedIcon,
    "aria-selected": selected,
    focused: focused,
    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : -1,
    selected: selected,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Menu/index.ts

Menu_Menu.displayName = "MenuBase";
Menu_Item.displayName = "Menu.Item";

// EXTERNAL MODULE: ../../libs/matcha/components/Modal/index.ts + 2 modules
var Modal = __webpack_require__(33400);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/usePortal/index.ts
var usePortal = __webpack_require__(47694);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/Select.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed51x407"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);
var ModalHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ed51x406"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var MenuWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed51x405"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var EmptyState = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ed51x404"
} : 0)( true ? {
  name: "14k1tly",
  styles: "margin:0;padding:14px 16px;text-align:center"
} : 0);
var Select_views_Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Menu_Menu,  true ? {
  target: "ed51x403"
} : 0)("width:100%;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{box-shadow:none;border:none;}", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-height:385px;overflow-y:auto;}" + ( true ? "" : 0));
var ClosingIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ed51x402"
} : 0)("cursor:pointer;color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";" + ( true ? "" : 0));
var ModalBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Modal/* Body */.uT,  true ? {
  target: "ed51x401"
} : 0)( true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0);
var ButtonsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed51x400"
} : 0)( true ? {
  name: "10ezsqn",
  styles: "display:grid;grid-auto-flow:column;gap:32px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/Select.tsx


var Select_excluded = ["filteredOptions", "getItemProps", "getPopperAttributes", "open", "listItemComponent", "tokens"],
    Select_excluded2 = ["open", "modalRef", "filteredOptions", "getItemProps", "menuProps", "onAccept", "onCancel", "mobileConfirmationBehaviour", "listItemComponent", "modalHeadline", "tokens"];

function Select_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Select_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Select_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Select_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
















var SelectMenu = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var filteredOptions = _ref.filteredOptions,
      getItemProps = _ref.getItemProps,
      getPopperAttributes = _ref.getPopperAttributes,
      open = _ref.open,
      listItemComponent = _ref.listItemComponent,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Select_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var desktopResolutionMediaQuery = theme.breakpoints.up("lg", false);
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(desktopResolutionMediaQuery, true);

  var menuProps = Select_objectSpread({
    layout: isDesktopResolution
  }, rest);

  var ListItemComponent = listItemComponent;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuWrapper, Select_objectSpread(Select_objectSpread({}, getPopperAttributes === null || getPopperAttributes === void 0 ? void 0 : getPopperAttributes()), {}, {
    ref: ref,
    children: open && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Select_views_Menu, Select_objectSpread(Select_objectSpread({}, menuProps), {}, {
      children: [filteredOptions.map(function (el, index) {
        return (// eslint-disable-next-line react/jsx-key
          (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemComponent, Select_objectSpread(Select_objectSpread({}, getItemProps(el, index)), {}, {
            children: el.text
          }))
        );
      }), !filteredOptions.length && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyState, {
        tag: "div",
        variant: "formHint",
        tokens: tokens.emptyState,
        children: "No options"
      })]
    }))
  }));
});
var DesktopWrapper = SelectMenu;

var ModalWrapper = function ModalWrapper(_ref2) {
  var open = _ref2.open,
      modalRef = _ref2.modalRef,
      filteredOptions = _ref2.filteredOptions,
      getItemProps = _ref2.getItemProps,
      menuProps = _ref2.menuProps,
      onAccept = _ref2.onAccept,
      onCancel = _ref2.onCancel,
      mobileConfirmationBehaviour = _ref2.mobileConfirmationBehaviour,
      listItemComponent = _ref2.listItemComponent,
      modalHeadline = _ref2.modalHeadline,
      tokens = _ref2.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, Select_excluded2);

  var portal = (0,usePortal/* default */.Z)(rest.id);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: open && /*#__PURE__*/(0,react_dom.createPortal)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* default */.ZP, Select_objectSpread(Select_objectSpread({
      ref: modalRef
    }, rest), {}, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Modal/* Head */.Fb, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalHeading, {
          tokens: tokens.modal.heading,
          variant: "buttonLarge",
          children: modalHeadline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClosingIcon, Select_objectSpread(Select_objectSpread({
          onClick: function onClick() {
            return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
          },
          "aria-label": "Close the modal"
        }, tokens.modal.closeIcon), {}, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
            size: "large"
          })
        }))]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalBody, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectMenu, Select_objectSpread({
          listItemComponent: listItemComponent,
          filteredOptions: filteredOptions,
          getItemProps: getItemProps,
          open: true,
          tokens: tokens.menu
        }, menuProps))
      }), mobileConfirmationBehaviour && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal/* Footer */.$_, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonsWrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            size: "small",
            onClick: function onClick() {
              return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            },
            "aria-label": "Cancel",
            tokens: tokens.modal.cancelButton,
            children: "Cancel"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            size: "small",
            onClick: function onClick() {
              onAccept === null || onAccept === void 0 ? void 0 : onAccept();
            },
            tokens: tokens.modal.doneButton,
            children: "Done"
          })]
        })
      })]
    })), portal)
  });
};

var BaseSelect = /*#__PURE__*/(0,react.forwardRef)(function (_ref3, ref) {
  var id = _ref3.id,
      filteredOptions = _ref3.filteredOptions,
      onAccept = _ref3.onAccept,
      onCancel = _ref3.onCancel,
      getPopperAttributes = _ref3.getPopperAttributes,
      getMenuContainerProps = _ref3.getMenuContainerProps,
      getMenuListProps = _ref3.getMenuListProps,
      getItemProps = _ref3.getItemProps,
      open = _ref3.open,
      displayMode = _ref3.displayMode,
      modalRef = _ref3.modalRef,
      externalAppearance = _ref3.appearance,
      _ref3$mobileConfirmat = _ref3.mobileConfirmationBehaviour,
      mobileConfirmationBehaviour = _ref3$mobileConfirmat === void 0 ? true : _ref3$mobileConfirmat,
      _ref3$listItemCompone = _ref3.listItemComponent,
      listItemComponent = _ref3$listItemCompone === void 0 ? Menu_Item : _ref3$listItemCompone,
      ariaLabel = _ref3.ariaLabel,
      _ref3$modalHeadline = _ref3.modalHeadline,
      modalHeadline = _ref3$modalHeadline === void 0 ? "Select a category" : _ref3$modalHeadline,
      tokens = _ref3.tokens;
  var menuProps = getMenuListProps();
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var placementWrapper = null;

  if (displayMode === "desktop") {
    placementWrapper = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopWrapper, Select_objectSpread({
      id: id,
      filteredOptions: filteredOptions,
      getItemProps: getItemProps,
      getPopperAttributes: getPopperAttributes,
      open: open,
      listItemComponent: listItemComponent,
      "aria-label": ariaLabel,
      tokens: tokens.menu
    }, getMenuContainerProps(menuProps)));
  }

  if (displayMode === "mobile") {
    placementWrapper = (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalWrapper, Select_objectSpread({
      id: id,
      filteredOptions: filteredOptions,
      open: open,
      modalRef: modalRef,
      modalHeadline: modalHeadline,
      menuProps: menuProps,
      getItemProps: getItemProps,
      onAccept: onAccept,
      onCancel: onCancel,
      mobileConfirmationBehaviour: mobileConfirmationBehaviour,
      listItemComponent: listItemComponent,
      tokens: tokens
    }, getMenuContainerProps()));
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      ref: ref,
      children: placementWrapper
    })
  });
});
var Select = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSelect, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.brand.darkAcai[500]
        }
      },
      modal: {
        heading: {
          color: theme.palette.neutrals.black[100]
        },
        closeIcon: {
          color: theme.palette.brand.darkAcai[700]
        },
        doneButton: {
          textColor: theme.palette.brand.darkAcai[700],
          hoverColor: theme.palette.brand.darkAcai[700]
        },
        cancelButton: {
          textColor: theme.palette.brand.darkAcai[500],
          hoverColor: theme.palette.brand.darkAcai[500]
        }
      }
    };
  },
  dark: function dark(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.brand.darkAcai[400]
        }
      },
      modal: {
        heading: {
          color: theme.palette.neutrals.white[100]
        },
        closeIcon: {
          color: theme.palette.neutrals.white[100]
        },
        doneButton: {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        },
        cancelButton: {
          textColor: theme.palette.brand.darkAcai[400],
          hoverColor: theme.palette.brand.darkAcai[400]
        }
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.twilio.gray[80]
        }
      },
      modal: {
        heading: {
          color: theme.palette.twilio.gray[100]
        },
        closeIcon: {
          color: theme.palette.twilio.gray[100]
        },
        doneButton: {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        },
        cancelButton: {
          textColor: theme.palette.twilio.gray[80],
          hoverColor: theme.palette.twilio.gray[80]
        }
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.twilio.gray[80]
        }
      },
      modal: {
        heading: {
          color: theme.palette.twilio.gray[100]
        },
        closeIcon: {
          color: theme.palette.twilio.gray[100]
        },
        doneButton: {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        },
        cancelButton: {
          textColor: theme.palette.twilio.gray[80],
          hoverColor: theme.palette.twilio.gray[80]
        }
      }
    };
  }
});
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(38128);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/MenuItemWithCheckbox.views.ts


function MenuItemWithCheckbox_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var MenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Menu_Item,  true ? {
  target: "e1s08f8e1"
} : 0)("display:grid;grid-template-columns:32px auto;", function (_ref) {
  var checked = _ref.checked,
      hoverBorderColor = _ref.hoverBorderColor;
  return !checked &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(":hover{", MenuItemCheckbox, "{::before{border-color:", hoverBorderColor, ";}}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var MenuItemCheckbox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Checkbox/* default */.Z,  true ? {
  target: "e1s08f8e0"
} : 0)( true ? {
  name: "1j97xhc",
  styles: "margin-right:12px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/MenuItemWIthCheckbox.tsx


var MenuItemWIthCheckbox_excluded = ["children", "tokens"];

function MenuItemWIthCheckbox_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function MenuItemWIthCheckbox_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? MenuItemWIthCheckbox_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MenuItemWIthCheckbox_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseMenuItemWithCheckbox = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, MenuItemWIthCheckbox_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem, MenuItemWIthCheckbox_objectSpread(MenuItemWIthCheckbox_objectSpread(MenuItemWIthCheckbox_objectSpread({
    checked: Boolean(rest.selected),
    selectedIcon: false,
    ref: ref
  }, rest), tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItemCheckbox, {
      name: String(children),
      checked: rest.selected,
      tag: "span"
    }), children]
  }));
});
var MenuItemWithCheckbox = (0,useDesignTokens/* withDesignTokens */.Y)(BaseMenuItemWithCheckbox, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      hoverBorderColor: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      hoverBorderColor: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverBorderColor: theme.palette.twilio.gray[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      hoverBorderColor: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var MenuItemWIthCheckbox = (MenuItemWithCheckbox);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/ClearSelect.views.ts

var ClearSelect = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evisesx0"
} : 0)("width:14px;height:14px;border-radius:50%;display:flex;justify-content:center;align-items:center;background-color:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/ClearSelect.tsx


var ClearSelect_excluded = ["children", "tokens"];

function ClearSelect_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ClearSelect_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ClearSelect_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ClearSelect_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseClearSelect = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ClearSelect_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClearSelect, ClearSelect_objectSpread(ClearSelect_objectSpread(ClearSelect_objectSpread({
    ref: ref
  }, rest), tokens), {}, {
    children: children
  }));
});
var ClearSelect_ClearSelect = (0,useDesignTokens/* withDesignTokens */.Y)(BaseClearSelect, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[400],
      color: theme.palette.neutrals.white[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[400],
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[40],
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[40],
      color: theme.palette.neutrals.white[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/index.ts



Select.displayName = "SelectBase";
ClearSelect_ClearSelect.displayName = "Select.ClearSelect";


/***/ }),

/***/ 27431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useSelect_useSelect; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/typesafe-actions/dist/typesafe-actions.umd.production.js
var typesafe_actions_umd_production = __webpack_require__(32145);
// EXTERNAL MODULE: ../../node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(76665);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(27866);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useKey.js + 1 modules
var useKey = __webpack_require__(2095);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(72489);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/usePopper.js + 55 modules
var usePopper = __webpack_require__(89623);
;// CONCATENATED MODULE: ../../libs/matcha/components/Menu/useMenu/useMenu.tsx




var _excluded = ["onClick", "ref", "onBlur", "style", "className"],
    _excluded2 = ["onMouseLeave", "ref"],
    _excluded3 = ["onMouseDown"],
    _excluded4 = ["onMouseEnter", "onClick"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var controlledKeys = [" ", "ArrowDown", "ArrowUp", "Enter", "Escape"];
var CLICKED_AWAY = "CLICKED_AWAY";
var CONTROL_BLURRED = "CONTROL_BLURRED";
var CONTROL_CLICKED = "CONTROL_CLICKED";
var ITEM_CLICKED = "ITEM_CLICKED";
var ITEM_MOUSE_ENTERED = "ITEM_MOUSE_ENTERED";
var KEY_PRESSED = "KEY_PRESSED";
var MENU_MOUSE_LEFT = "MENU_MOUSE_LEFT";
var MENU_CONTAINER_MOUSE_DOWN = "MENU_CONTAINER_MOUSE_DOWN";
var MOUSE_UP = "MOUSE_UP";
var clickedAwayAction = (0,typesafe_actions_umd_production.createAction)(CLICKED_AWAY)();
var controlBlurredAction = (0,typesafe_actions_umd_production.createAction)(CONTROL_BLURRED)();
var controlClickedAction = (0,typesafe_actions_umd_production.createAction)(CONTROL_CLICKED)();
var itemClickedAction = (0,typesafe_actions_umd_production.createAction)(ITEM_CLICKED)();
var itemMouseEnteredAction = (0,typesafe_actions_umd_production.createAction)(ITEM_MOUSE_ENTERED)();
var keyPressedAction = (0,typesafe_actions_umd_production.createAction)(KEY_PRESSED)();
var menuMouseLeftAction = (0,typesafe_actions_umd_production.createAction)(MENU_MOUSE_LEFT)();
var menuContainerMouseDownAction = (0,typesafe_actions_umd_production.createAction)(MENU_CONTAINER_MOUSE_DOWN)();
var mouseUpAction = (0,typesafe_actions_umd_production.createAction)(MOUSE_UP)();

var updateSelectedState = function updateSelectedState(draft, option, _ref) {
  var _original;

  var multiselect = _ref.multiselect;
  var originalSelected = (_original = (0,immer_esm/* original */.Js)(draft.selected)) !== null && _original !== void 0 ? _original : [];
  var index = originalSelected.findIndex(function (item) {
    return item === option;
  });

  if (index === -1) {
    var _original2;

    draft.previous = (_original2 = (0,immer_esm/* original */.Js)(draft.selected)) !== null && _original2 !== void 0 ? _original2 : null;
    if (!multiselect) draft.selected = [];
    draft.selected.push(option);
  } else if (multiselect) {
    var _original3;

    draft.previous = (_original3 = (0,immer_esm/* original */.Js)(draft.selected)) !== null && _original3 !== void 0 ? _original3 : null;
    draft.selected.splice(index, 1);
  }
};

var handlePressedKey = function handlePressedKey(draft, _ref2, config) {
  var key = _ref2.key,
      isControlFocused = _ref2.isControlFocused;

  switch (key) {
    case "Escape":
      {
        if (draft.open) {
          draft.open = false;
          draft.focused = draft.lastTriggeredItem;
        }

        break;
      }

    case " ":
    case "Enter":
      {
        if (isControlFocused) {
          var originalFocused = draft.focused ? (0,immer_esm/* original */.Js)(draft.focused) : draft.focused;
          var originalOpened = draft.open;
          var originalOptions = (0,immer_esm/* original */.Js)(draft.options);

          if (!originalOpened && originalOptions) {
            draft.focused = originalOptions.length > 0 ? originalOptions[0] : null;
          }

          if (originalOpened && originalFocused) {
            if (config.selectable) {
              updateSelectedState(draft, originalFocused, config);
            }

            draft.lastTriggeredItem = draft.focused;

            if (config.closeOnSelect) {
              draft.open = false;
            }
          }
        }

        break;
      }

    case "ArrowDown":
      {
        if (isControlFocused) draft.open = true;

        if (draft.open) {
          var _original4;

          var _originalFocused = draft.focused ? (0,immer_esm/* original */.Js)(draft.focused) : draft.focused;

          var _originalOptions = (_original4 = (0,immer_esm/* original */.Js)(draft.options)) !== null && _original4 !== void 0 ? _original4 : [];

          var focusedIndex = _originalOptions.findIndex(function (o) {
            return o === _originalFocused;
          });

          if (focusedIndex < draft.options.length - 1) {
            draft.focused = _originalOptions[focusedIndex + 1];
          }
        }

        break;
      }

    case "ArrowUp":
      {
        if (isControlFocused) draft.open = true;

        if (draft.open) {
          var _original5;

          var _originalFocused2 = draft.focused ? (0,immer_esm/* original */.Js)(draft.focused) : draft.focused;

          var _originalOptions2 = (_original5 = (0,immer_esm/* original */.Js)(draft.options)) !== null && _original5 !== void 0 ? _original5 : [];

          var _focusedIndex = _originalOptions2.findIndex(function (o) {
            return o === _originalFocused2;
          });

          if (_focusedIndex === -1 && _originalOptions2.length > 0) _focusedIndex = _originalOptions2.length;

          if (_focusedIndex > 0) {
            draft.focused = _originalOptions2[_focusedIndex - 1];
          }
        }

        break;
      }

    default:
  }
};

var createMenuReducer = function createMenuReducer(config) {
  return (0,immer_esm/* produce */.Uy)(function (state, action) {
    switch (action.type) {
      case CLICKED_AWAY:
        {
          state.open = false;
          return;
        }

      case CONTROL_CLICKED:
        {
          state.open = !state.open;
          return;
        }

      case ITEM_CLICKED:
        {
          state.lastTriggeredItem = action.payload;

          if (config.closeOnSelect && state.open && !config.multiselect) {
            state.open = false;
          }

          if (!config.selectable) {
            return;
          }

          updateSelectedState(state, action.payload, config);
          return;
        }

      case CONTROL_BLURRED:
        {
          state.open = false;
          return;
        }

      case ITEM_MOUSE_ENTERED:
        {
          state.focused = action.payload;
          return;
        }

      case MENU_MOUSE_LEFT:
        {
          state.focused = null;
          return;
        }

      case KEY_PRESSED:
        {
          handlePressedKey(state, action.payload, config);
          return;
        }

      case MENU_CONTAINER_MOUSE_DOWN:
        {
          state.menuContainerMouseDown = true;
          return;
        }

      case MOUSE_UP:
        {
          state.menuContainerMouseDown = false;
          return;
        }

      default:
        {
          throw new Error("Unhandled action type: ".concat(JSON.stringify(action)));
        }
    }
  });
};
var init = function init(_ref3) {
  var initialSelected = _ref3.initialSelected,
      initialOpen = _ref3.initialOpen,
      options = _ref3.options;
  return {
    selected: initialSelected,
    previous: null,
    lastTriggeredItem: null,
    open: initialOpen,
    options: options,
    focused: null,
    menuContainerMouseDown: false
  };
};
var offsetModifier = {
  name: "offset",
  options: {
    offset: [0, 10]
  }
};
var DEFAULT_POPPER_MODIFIERS = [offsetModifier];

var useMenuReducer = function useMenuReducer(_ref4) {
  var closeOnSelect = _ref4.closeOnSelect,
      interactive = _ref4.interactive,
      multiselect = _ref4.multiselect,
      selectable = _ref4.selectable,
      options = _ref4.options,
      externalReducer = _ref4.reducer,
      externalInit = _ref4.init,
      _ref4$initialOpen = _ref4.initialOpen,
      initialOpen = _ref4$initialOpen === void 0 ? false : _ref4$initialOpen,
      _ref4$initialSelected = _ref4.initialSelected,
      initialSelected = _ref4$initialSelected === void 0 ? [] : _ref4$initialSelected;
  var createMenuReducerParametrized = (0,react.useCallback)(function () {
    return createMenuReducer({
      selectable: selectable,
      interactive: interactive,
      closeOnSelect: closeOnSelect,
      multiselect: multiselect
    });
  }, [selectable, interactive, closeOnSelect, multiselect]);
  var reducer = (0,react.useMemo)(function () {
    return externalReducer ? externalReducer : createMenuReducerParametrized();
  }, [externalReducer, createMenuReducerParametrized]);
  var finalInit = externalInit ? externalInit : init;
  return (0,react.useReducer)(reducer, {
    initialSelected: initialSelected,
    initialOpen: initialOpen,
    selectable: selectable,
    interactive: interactive,
    closeOnSelect: closeOnSelect,
    multiselect: multiselect,
    options: options
  }, finalInit);
};

var useMenu = function useMenu(_ref5) {
  var id = _ref5.id,
      _ref5$initialSelected = _ref5.initialSelected,
      initialSelected = _ref5$initialSelected === void 0 ? [] : _ref5$initialSelected,
      _ref5$initialOpen = _ref5.initialOpen,
      initialOpen = _ref5$initialOpen === void 0 ? false : _ref5$initialOpen,
      onSelect = _ref5.onSelect,
      reducer = _ref5.reducer,
      init = _ref5.init,
      _ref5$config = _ref5.config;
  _ref5$config = _ref5$config === void 0 ? {} : _ref5$config;
  var _ref5$config$selectab = _ref5$config.selectable,
      selectable = _ref5$config$selectab === void 0 ? false : _ref5$config$selectab,
      _ref5$config$interact = _ref5$config.interactive,
      interactive = _ref5$config$interact === void 0 ? true : _ref5$config$interact,
      _ref5$config$closeOnS = _ref5$config.closeOnSelect,
      closeOnSelect = _ref5$config$closeOnS === void 0 ? true : _ref5$config$closeOnS,
      _ref5$config$multisel = _ref5$config.multiselect,
      multiselect = _ref5$config$multisel === void 0 ? false : _ref5$config$multisel,
      _ref5$config$popperMo = _ref5$config.popperModifiers,
      popperModifiers = _ref5$config$popperMo === void 0 ? DEFAULT_POPPER_MODIFIERS : _ref5$config$popperMo,
      _ref5$config$placemen = _ref5$config.placement,
      placement = _ref5$config$placemen === void 0 ? "bottom" : _ref5$config$placemen,
      _ref5$config$strategy = _ref5$config.strategy,
      strategy = _ref5$config$strategy === void 0 ? "absolute" : _ref5$config$strategy,
      _ref5$options = _ref5.options,
      options = _ref5$options === void 0 ? [] : _ref5$options;
  var controlRef = (0,react.useRef)(null);
  var menuListRef = (0,react.useRef)(null);

  var _useMenuReducer = useMenuReducer({
    selectable: selectable,
    interactive: interactive,
    closeOnSelect: closeOnSelect,
    multiselect: multiselect,
    options: options,
    reducer: reducer,
    init: init,
    initialOpen: initialOpen,
    initialSelected: initialSelected
  }),
      _useMenuReducer2 = (0,slicedToArray/* default */.Z)(_useMenuReducer, 2),
      state = _useMenuReducer2[0],
      dispatch = _useMenuReducer2[1];

  (0,react.useEffect)(function () {
    var listener = function listener() {
      dispatch(mouseUpAction());
    };

    window.addEventListener("mouseup", listener);
    return function () {
      window.removeEventListener("mouseup", listener);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var focusedIndex = (0,react.useMemo)(function () {
    return state.options.findIndex(function (o) {
      return o === state.focused;
    });
  }, [state.options, state.focused]);
  (0,useClickAway/* default */.Z)({
    current: menuListRef.current
  }, function (event) {
    var control = controlRef.current;

    if (event.target !== control && (event.target || !(control !== null && control !== void 0 && control.contains(event.target)))) {
      dispatch(clickedAwayAction());
    }
  });

  var _usePopper = (0,usePopper/* usePopper */.D)(controlRef.current, menuListRef.current, {
    modifiers: popperModifiers,
    placement: placement,
    strategy: strategy
  }),
      popperAttributes = _usePopper.attributes,
      popperStyles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate;

  (0,useKey/* default */.Z)(function (e) {
    return controlledKeys.includes(e.key);
  }, function (e) {
    if (state.open) {
      e.preventDefault();
    }

    dispatch(keyPressedAction({
      key: e.key,
      isControlFocused: document.activeElement === controlRef.current
    }));
  });
  (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
    forceUpdate === null || forceUpdate === void 0 ? void 0 : forceUpdate();
  }, [state.open]);
  (0,react.useEffect)(function () {
    if (state.lastTriggeredItem && !selectable) {
      onSelect === null || onSelect === void 0 ? void 0 : onSelect([state.lastTriggeredItem]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [state.lastTriggeredItem]);
  (0,react.useEffect)(function () {
    if (state.previous && state.selected !== state.previous) {
      onSelect === null || onSelect === void 0 ? void 0 : onSelect((0,toConsumableArray/* default */.Z)(state.selected), (0,toConsumableArray/* default */.Z)(state.previous));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [state.selected, state.previous]);
  var typedDispatch = dispatch;
  var typedState = state;
  return {
    focusedIndex: focusedIndex,
    open: state.open,
    state: typedState,
    dispatch: typedDispatch,
    interactive: interactive || selectable,
    // eslint-disable-next-line object-shorthand
    getControlProps: function getControlProps() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _onClick = _ref6.onClick,
          _ref7 = _ref6.ref,
          _onBlur = _ref6.onBlur,
          style = _ref6.style,
          className = _ref6.className,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded);

      return _objectSpread({
        'aria-haspopup': "listbox",
        onClick: function onClick(e) {
          dispatch(controlClickedAction());
          _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
        },
        onBlur: function onBlur(e) {
          if (!state.menuContainerMouseDown) {
            dispatch(controlBlurredAction());
            _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
          }
        },
        ref: function ref(r) {
          if (_ref7) {
            if (typeof _ref7 === "function") {
              _ref7(r);
            } else {
              var mutableRef = _ref7;
              mutableRef.current = r;
            }
          }

          controlRef.current = r;
        },
        style: _objectSpread(_objectSpread({}, popperStyles.reference), style),
        className: className
      }, rest);
    },
    // eslint-disable-next-line object-shorthand
    getMenuListProps: function getMenuListProps() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _onMouseLeave = _ref8.onMouseLeave,
          _ref9 = _ref8.ref,
          props = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded2);

      var focusedId = props.id ? props.id : focusedIndex >= 0 ? focusedIndex : null;
      return _objectSpread({
        role: "listbox",
        tabindex: -1,
        'aria-activedescendant': focusedId !== undefined && focusedId !== null ? focusedId.toString() : undefined,
        interactive: true,
        onMouseLeave: function onMouseLeave(e) {
          dispatch(menuMouseLeftAction());
          _onMouseLeave === null || _onMouseLeave === void 0 ? void 0 : _onMouseLeave(e);
        },
        ref: function ref(r) {
          if (_ref9) {
            if (typeof _ref9 === "function") {
              _ref9(r);
            } else {
              var mutableRef = _ref9;
              mutableRef.current = r;
            }
          }

          menuListRef.current = r;
        }
      }, props);
    },
    getPopperAttributes: function getPopperAttributes() {
      var style = _objectSpread({}, popperStyles.popper);

      if (!state.open) {
        style.display = "none";
      }

      return _objectSpread(_objectSpread({}, popperAttributes.popper), {}, {
        style: style
      });
    },
    // eslint-disable-next-line object-shorthand
    getMenuContainerProps: function getMenuContainerProps() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _onMouseDown = _ref10.onMouseDown,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref10, _excluded3);

      return _objectSpread({
        onMouseDown: function onMouseDown(e) {
          dispatch(menuContainerMouseDownAction());
          _onMouseDown === null || _onMouseDown === void 0 ? void 0 : _onMouseDown(e);
        }
      }, rest);
    },
    // eslint-disable-next-line object-shorthand
    getItemProps: function getItemProps(item, index) {
      var _ref11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _onMouseEnter = _ref11.onMouseEnter,
          _onClick2 = _ref11.onClick,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref11, _excluded4);

      var selected = state.selected.some(function (el) {
        return el === item;
      });
      return _objectSpread({
        id: "".concat(id, "-").concat(index),
        value: item.value,
        key: item.value,
        selected: selected,
        focused: state.focused === item,
        onMouseEnter: function onMouseEnter(e) {
          dispatch(itemMouseEnteredAction(item));
          _onMouseEnter === null || _onMouseEnter === void 0 ? void 0 : _onMouseEnter(e);
        },
        onClick: function onClick(e) {
          dispatch(itemClickedAction(item));
          _onClick2 === null || _onClick2 === void 0 ? void 0 : _onClick2(e);
        },
        role: "option",
        'aria-selected': selected
      }, rest);
    },
    getSelectedItems: function getSelectedItems() {
      return state.selected;
    }
  };
};
/* harmony default export */ var useMenu_useMenu = (useMenu);
;// CONCATENATED MODULE: ../../libs/matcha/components/Menu/useMenu/index.ts


// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/useSelect/useSelect.tsx



var useSelect_excluded = ["onChange", "placeholder", "counter"],
    useSelect_excluded2 = ["selected"];

function useSelect_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function useSelect_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? useSelect_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useSelect_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}







var INPUT_CHANGED = "INPUT_CHANGED";
var ACCEPT_BUTTON_CLICKED = "ACCEPT_BUTTON_CLICKED";
var CANCEL_BUTTON_CLICKED = "CANCEL_BUTTON_CLICKED";
var DISPLAY_MODE_CHANGED = "DISPLAY_MODE_CHANGED";
var acceptButtonClickedAction = (0,typesafe_actions_umd_production.createAction)(ACCEPT_BUTTON_CLICKED)();
var cancelButtonClickedAction = (0,typesafe_actions_umd_production.createAction)(CANCEL_BUTTON_CLICKED)();
var inputChangedAction = (0,typesafe_actions_umd_production.createAction)(INPUT_CHANGED)();
var displayModeChangedAction = (0,typesafe_actions_umd_production.createAction)(DISPLAY_MODE_CHANGED)();

var mergeStates = function mergeStates(draft, newState) {
  return Object.entries(newState).forEach(function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        k = _ref3[0],
        v = _ref3[1];

    draft[k] = v;
  });
};

var updatePreselectedState = function updatePreselectedState(draft, option, _ref4) {
  var _originalPreselected$;

  var multiselect = _ref4.multiselect;
  var originalPreselected = (0,immer_esm/* original */.Js)(draft.preselected);
  var index = (_originalPreselected$ = originalPreselected === null || originalPreselected === void 0 ? void 0 : originalPreselected.findIndex(function (item) {
    return item === option;
  })) !== null && _originalPreselected$ !== void 0 ? _originalPreselected$ : -1;

  if (index === -1) {
    if (!multiselect) draft.preselected = [];
    draft.preselected.push(option);
  } else if (multiselect) {
    draft.preselected.splice(index, 1);
  }
};

var useSelectReducer = function useSelectReducer(config) {
  var baseReducer = createMenuReducer(config);
  return (0,immer_esm/* produce */.Uy)(function (state, action) {
    switch (action.type) {
      case INPUT_CHANGED:
        {
          state.filterValue = action.payload;
          state.open = true;
          return;
        }

      case DISPLAY_MODE_CHANGED:
        state.displayMode = action.payload;
        return;

      case CLICKED_AWAY:
        {
          switch (state.displayMode) {
            case "desktop":
              mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
              break;

            case "mobile":
              {
                break;
              }

            default:
              throw new Error("Unexpected displayMode: ".concat(state.displayMode));
          }

          break;
        }

      case CONTROL_CLICKED:
        mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
        state.filterValue = "";
        state.preselected = state.selected;
        return;

      case CONTROL_BLURRED:
        {
          switch (state.displayMode) {
            case "desktop":
              mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
              state.filterValue = "";
              break;

            case "mobile":
              {
                break;
              }

            default:
              throw new Error("Unexpected displayMode: ".concat(state.displayMode));
          }

          break;
        }

      case ITEM_CLICKED:
        {
          var displayMode = config.mobileConfirmationBehaviour ? state.displayMode : "desktop";

          switch (displayMode) {
            case "desktop":
              mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
              state.filterValue = "";
              return;

            case "mobile":
              {
                var option = action.payload;
                state.lastTriggeredItem = option;
                state.filterValue = "";
                updatePreselectedState(state, option, config);
                break;
              }

            default:
              throw new Error("Unexpected displayMode: ".concat(state.displayMode));
          }

          break;
        }

      case ACCEPT_BUTTON_CLICKED:
        {
          state.previous = state.selected;
          state.selected = state.preselected;
          state.open = false;
          break;
        }

      case CANCEL_BUTTON_CLICKED:
        {
          state.preselected = state.selected;
          state.open = false;
          break;
        }

      case KEY_PRESSED:
        {
          var _displayMode = config.mobileConfirmationBehaviour ? state.displayMode : "desktop";

          switch (_displayMode) {
            case "desktop":
              switch (action.payload.key) {
                case "Escape":
                case "Enter":
                  mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
                  state.filterValue = "";
                  break;

                case " ":
                  if (state.open && !state.focused) {
                    state.filterValue += " ";
                  } else {
                    state.filterValue = "";
                  }

                  mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
                  break;

                default:
                  mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
                  break;
              }

              break;

            case "mobile":
              {
                switch (action.payload.key) {
                  case "Escape":
                    mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
                    state.filterValue = "";
                    break;

                  case " ":
                  case "Enter":
                    if (state.open) {
                      state.lastTriggeredItem = state.focused;
                      state.filterValue = "";
                    }

                    if (state.open && state.focused) {
                      updatePreselectedState(state, state.focused, config);
                    }

                    if (action.payload.isControlFocused) {
                      state.open = true;
                    }

                    break;

                  default:
                    mergeStates(state, baseReducer((0,immer_esm/* current */.Vk)(state), action));
                    break;
                }

                break;
              }

            default:
              throw new Error("Unexpected displayMode: ".concat(state.displayMode));
          }

          break;
        }

      default:
        return baseReducer((0,immer_esm/* current */.Vk)(state), action);
    }
  });
};

var filterOptions = function filterOptions(options, filterValue) {
  var _filterValue$replace; // Replaces any special char in filtering string with its literal counterpart
  // 'foo?bar' => 'foo\?bar'


  var filteringRegexp = new RegExp((_filterValue$replace = filterValue === null || filterValue === void 0 ? void 0 : filterValue.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1")) !== null && _filterValue$replace !== void 0 ? _filterValue$replace : "", "i");
  return options.filter(function (option) {
    return filteringRegexp.test(option.text);
  });
};

var useReducerInit = function useReducerInit(_ref5) {
  var isDesktopResolution = _ref5.isDesktopResolution;
  return function (props) {
    var baseState = init(props);
    return useSelect_objectSpread(useSelect_objectSpread({}, baseState), {}, {
      preselected: baseState.selected,
      displayMode: isDesktopResolution ? "desktop" : "mobile",
      filterValue: ""
    });
  };
};

var _ref =  true ? {
  name: "1egt7yx",
  styles: "&::placeholder{opacity:1;color:currentColor;}"
} : 0;

var useSelect = function useSelect(_ref6) {
  var _ref6$initialSelected = _ref6.initialSelected,
      initialSelected = _ref6$initialSelected === void 0 ? [] : _ref6$initialSelected,
      _ref6$useControlledSt = _ref6.useControlledState,
      useControlledState = _ref6$useControlledSt === void 0 ? function (s) {
    return s;
  } : _ref6$useControlledSt,
      id = _ref6.id,
      options = _ref6.options,
      onSelect = _ref6.onSelect,
      label = _ref6.label,
      _isDesktopResolutionDefault = _ref6._isDesktopResolutionDefault,
      _ref6$config = _ref6.config,
      config = _ref6$config === void 0 ? {
    mobileConfirmationBehaviour: true,
    multiselect: false
  } : _ref6$config;
  var modalRef = (0,react.useRef)(null);
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var desktopResolutionMediaQuery = theme.breakpoints.up("lg", false);
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(desktopResolutionMediaQuery, _isDesktopResolutionDefault !== null && _isDesktopResolutionDefault !== void 0 ? _isDesktopResolutionDefault : true);
  var menuConfig = {
    selectable: true,
    closeOnSelect: true,
    interactive: true,
    multiselect: false
  };
  var init = useReducerInit({
    isDesktopResolution: isDesktopResolution
  });
  var reducer = useSelectReducer(useSelect_objectSpread(useSelect_objectSpread({}, menuConfig), config));

  var _useMenu = useMenu_useMenu({
    id: id,
    reducer: reducer,
    init: init,
    options: options,
    config: {
      selectable: true,
      closeOnSelect: true
    },
    initialSelected: initialSelected,
    onSelect: onSelect
  }),
      menuState = _useMenu.state,
      dispatch = _useMenu.dispatch,
      _getControlProps = _useMenu.getControlProps,
      getPopperAttributes = _useMenu.getPopperAttributes,
      getMenuListProps = _useMenu.getMenuListProps,
      _getItemProps = _useMenu.getItemProps,
      getMenuContainerProps = _useMenu.getMenuContainerProps;

  var state = useControlledState(menuState);
  (0,react.useEffect)(function () {
    dispatch(displayModeChangedAction(isDesktopResolution ? "desktop" : "mobile")); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktopResolution]);
  var filteredOptions = (0,react.useMemo)(function () {
    return state.filterValue !== "" && state.displayMode === "desktop" ? filterOptions(state.options, state.filterValue) : state.options;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [state.options, state.filterValue]);

  var onAccept = function onAccept() {
    dispatch(acceptButtonClickedAction());
  };

  var onCancel = function onCancel() {
    dispatch(cancelButtonClickedAction());
  };

  var activeColor = _ref;
  return {
    state: state,
    dispatch: dispatch,
    filteredOptions: filteredOptions,
    // eslint-disable-next-line object-shorthand
    getControlProps: function getControlProps() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _onChange = _ref7.onChange,
          placeholder = _ref7.placeholder,
          counter = _ref7.counter,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref7, useSelect_excluded);

      var placeholderText = "".concat(placeholder);

      if (state.selected.length > 0) {
        placeholderText = counter ? "".concat(placeholder, " (").concat(state.selected.length, ")") : state.selected.map(function (s) {
          return s.text;
        }).join("; ");
      }

      return useSelect_objectSpread(useSelect_objectSpread({}, _getControlProps({
        css: state.selected.length > 0 ? activeColor : {}
      })), {}, {
        // eslint-disable-next-line object-shorthand
        onChange: function onChange(event, value) {
          var _ref8, _value, _event$target;

          var inputValue = (_ref8 = (_value = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _value !== void 0 ? _value : value) !== null && _ref8 !== void 0 ? _ref8 : "";
          dispatch(inputChangedAction(inputValue));
          _onChange === null || _onChange === void 0 ? void 0 : _onChange(event);
        },
        placeholder: placeholderText,
        'aria-label': label,
        value: state.filterValue,
        onClear: function onClear() {
          dispatch(inputChangedAction(""));
        },
        readOnly: state.displayMode === "mobile"
      }, rest);
    },
    getSelectProps: function getSelectProps() {
      return {
        getPopperAttributes: getPopperAttributes,
        getMenuListProps: getMenuListProps,
        getMenuContainerProps: getMenuContainerProps,
        getItemProps: function getItemProps(item, index, props) {
          var _getItemProps2 = _getItemProps(item, index, props),
              selected = _getItemProps2.selected,
              rest = (0,objectWithoutProperties/* default */.Z)(_getItemProps2, useSelect_excluded2);

          return useSelect_objectSpread({
            selected: state.displayMode === "desktop" ? selected : state.preselected.includes(item),
            label: label
          }, rest);
        },
        modalRef: modalRef,
        state: state,
        onAccept: onAccept,
        onCancel: onCancel,
        ariaLabel: label,
        mobileConfirmationBehaviour: config.mobileConfirmationBehaviour
      };
    }
  };
};
/* harmony default export */ var useSelect_useSelect = (useSelect);
;// CONCATENATED MODULE: ../../libs/matcha/components/Select/useSelect/index.ts


/***/ }),

/***/ 47694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _usePortal__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _usePortal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75290);


/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * Creates DOM element to be used as React root.
 */

function createRootElement(id) {
  var rootContainer = document.createElement("div");
  rootContainer.setAttribute("id", id);
  return rootContainer;
}
/**
 * Appends element as last child of body.
 */


function addRootElement(rootElem) {
  if (document.body.lastElementChild) {
    document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
  }
}
/**
 * Hook to create a React Portal.
 * Automatically handles creating and tearing-down the root elements (no SRR
 * makes this trivial), so there is no need to ensure the parent target already
 * exists.
 * @param id - The id of the root element to create.
 * @returns The root element.
 */


function usePortal(id) {
  var rootElemRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Look for existing target dom element to append to
    var existingParent = document.querySelector("#".concat(id)); // Parent is either a new root or the existing dom element

    var parentElem = existingParent || createRootElement(id); // If there is no existing DOM element, add a new one.

    if (!existingParent) {
      addRootElement(parentElem);
    } // Add the detached element to the parent


    if (rootElemRef.current) {
      parentElem.appendChild(rootElemRef.current);
    }

    return function () {
      var _rootElemRef$current;

      (_rootElemRef$current = rootElemRef.current) === null || _rootElemRef$current === void 0 ? void 0 : _rootElemRef$current.remove();

      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  /**
   * It's important we evaluate this lazily:
   * - We need first render to contain the DOM element, so it shouldn't happen
   *   in useEffect. We would normally put this in the constructor().
   * - We can't do 'const rootElemRef = useRef(document.createElement('div))',
   *   since this will run every single render (that's a lot).
   * - We want the ref to consistently point to the same DOM element and only
   *   ever run once.
   * @link https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
   */

  function getRootElem() {
    if (!rootElemRef.current && true) {
      rootElemRef.current = document.createElement("div");
    }

    return rootElemRef.current;
  }

  return getRootElem();
}

/* harmony default export */ __webpack_exports__["Z"] = (usePortal);

/***/ })

}]);